(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesController', VentamesController);

    VentamesController.$inject = ['Ventames'];

    function VentamesController(Ventames) {

        var vm = this;

        vm.ventames = [];

        loadAll();

        function loadAll() {
            Ventames.query(function(result) {
                vm.ventames = result;
                vm.searchQuery = null;
            });
        }
    }
})();
